import { render } from "./SlackEditor.vue?vue&type=template&id=c18187ba"
import script from "./SlackEditor.vue?vue&type=script&lang=js"
export * from "./SlackEditor.vue?vue&type=script&lang=js"

import "./SlackEditor.vue?vue&type=style&index=0&id=c18187ba&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__